import { ALL_BILTY_DATA } from "../constant/constant";



export const AllBiltyReport = function (state = [], action) {
  switch (action.type) {
    case ALL_BILTY_DATA:
      if (Array.isArray(action.payload)) {
        return action.payload;
      }
      if (action.payload && Array.isArray(action.payload.data)) {
        return action.payload.data;
      }
      return [];
    default: {
      return state;
    }
  }
};